import { applyUiChunk, createUiChunkSessionState } from "./processUiChunkStream";
import { _withAppMessageId } from "../../agentStoreUtils";
import { reduceTeamActivity } from "./teamActivityReducer";

// Rebuild the active projection from its durable checkpoint, never append replay
// deltas to a database message which may already include those same tokens.
export function hydrateStreamSnapshot(envelope) {
  const detail = envelope.payload || {};
  const entries = envelope.replayEvents || [];
  const touched = new Set();
  for (const { event } of entries) {
    const chunk = event.type === "ui_chunk" ? event.payload?.chunk : null;
    if (chunk?.type === "start" && chunk.messageId) touched.add(chunk.messageId);
    const message = event.type === "message_added" ? event.payload?.message : null;
    if (message) touched.add(message.messageId || message.id);
  }
  let messages = (detail.messages || []).map(_withAppMessageId)
    .filter((m) => !touched.has(m.messageId || m.id));
  let cursor = createUiChunkSessionState(detail.chatSessionId || envelope.sessionId);
  let team = {};
  let workers = {};
  let status = detail.status;
  for (const { event, sequence } of entries) {
    if (event.type === "ui_chunk") {
      ({ cursor, messages } = applyUiChunk(cursor, event.payload?.chunk, messages));
    } else if (event.type === "message_added" && event.payload?.message) {
      const message = { ..._withAppMessageId(event.payload.message),
        _streamSource: "persisted", _streamSequence: sequence };
      const index = messages.findIndex((m) => m.id === message.id);
      if (index < 0) messages.push(message);
      else messages[index] = message;
    } else if (event.type === "team_child_activity") {
      team = reduceTeamActivity(team, event.payload || {});
    } else if (event.type === "worker_status_changed" && event.payload?.workerSessionId) {
      workers[event.payload.workerSessionId] = event.payload;
    } else if (event.type === "status_changed") {
      status = typeof event.payload === "string" ? event.payload : event.payload?.status;
    } else if (event.type === "session_complete") {
      status = event.payload?.status || "COMPLETED";
      ({ cursor, messages } = applyUiChunk(cursor, { type: "finish" }, messages));
    }
  }
  return { detail: { ...detail, status, messages }, cursor, team, workers };
}
